import { businessUnitState } from '../initialState';
import { storeRemoveItem, storeUpdateObjectInArray } from '../utils/utils';

function withStatus(state, loading, error) {
  return Object.assign({}, state.businessUnitStatus, { loading, error });
}

function sortedByName(units) {
  return units.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '', 'fi'));
}

export default function (state = businessUnitState, action) {
  switch (action.type) {
    case 'FETCH_BUSINESS_UNITS_REQUEST': {
      return { ...state, businessUnitStatus: withStatus(state, true, null) };
    }
    case 'FETCH_BUSINESS_UNITS_SUCCESS': {
      return { ...state, businessUnits: action.payload, businessUnitStatus: withStatus(state, false, null) };
    }
    case 'FETCH_BUSINESS_UNITS_FAIL': {
      return { ...state, businessUnits: [], businessUnitStatus: withStatus(state, false, action.payload) };
    }
    case 'CREATE_BUSINESS_UNIT_REQUEST':
    case 'UPDATE_BUSINESS_UNIT_REQUEST':
    case 'DELETE_BUSINESS_UNIT_REQUEST': {
      return { ...state, businessUnitStatus: withStatus(state, true, null) };
    }
    case 'CREATE_BUSINESS_UNIT_SUCCESS': {
      return {
        ...state,
        businessUnits: sortedByName(state.businessUnits.concat([action.payload])),
        businessUnitStatus: withStatus(state, false, null),
      };
    }
    case 'UPDATE_BUSINESS_UNIT_SUCCESS': {
      return {
        ...state,
        businessUnits: sortedByName(storeUpdateObjectInArray(state.businessUnits, action.payload)),
        businessUnitStatus: withStatus(state, false, null),
      };
    }
    case 'DELETE_BUSINESS_UNIT_SUCCESS': {
      return {
        ...state,
        businessUnits: storeRemoveItem(state.businessUnits, action.additionalData.itemId),
        businessUnitStatus: withStatus(state, false, null),
      };
    }
    case 'CREATE_BUSINESS_UNIT_FAIL':
    case 'UPDATE_BUSINESS_UNIT_FAIL':
    case 'DELETE_BUSINESS_UNIT_FAIL': {
      return { ...state, businessUnitStatus: withStatus(state, false, action.payload) };
    }
    default:
      break;
  }
  return state;
}
